import { Box, Typography, Chip } from "@mui/material";
import { MainContext } from "../../../../main/context/MainContextProvider";
import { useContext } from "react";
import { SeverityTypesEnum } from "../../../alarms/types";
import { formatDateAndHour } from "../../../../main/utils/utils";
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';

export interface FalhaCardProps {
    severity: SeverityTypesEnum;
    usina: string;
    descricao: string;
    detalhes: string;
    tempo: string;
    dataHoraInicio: string;
    dataHoraFim?: string;
}

export default function FalhaCard({ severity, usina, descricao, detalhes, tempo, dataHoraInicio, dataHoraFim }: FalhaCardProps) {
    const { theme } = useContext(MainContext);

    const getSeverityColor = () => {
        switch (severity) {
            case SeverityTypesEnum.severe:
                return "#F85F56";
            case SeverityTypesEnum.medium:
                return "#FBBF24";
            case SeverityTypesEnum.bland:
                return "#47D27B";
            default:
                return "#888";
        }
    };

    const getSeverityLabel = () => {
        switch (severity) {
            case SeverityTypesEnum.severe:
                return "Severo";
            case SeverityTypesEnum.medium:
                return "Médio";
            case SeverityTypesEnum.bland:
                return "Brando";
            default:
                return "Não informado";
        }
    };

    return (
        <Box
            sx={{
                backgroundColor: "#202020b0",
                padding: "12px",
                borderRadius: "6px",
                border: `1px solid #334155`,
                marginBottom: "12px",
                "&:hover": {
                    backgroundColor: theme.backgroundColor,
                }
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", justifyContent: "space-between" }}>
                        <Chip
                            label={getSeverityLabel()}
                            size="small"
                            sx={{
                                backgroundColor: getSeverityColor(),
                                color: "#fff",
                                fontWeight: 600,
                                fontSize: "11px",
                                height: "20px"
                            }}
                        />
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "2px" }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}>
                                    <AccessTimeOutlinedIcon sx={{ color: getSeverityColor(), fontSize: "14px" }} />
                                    <Typography sx={{ fontSize: "12px", fontWeight: 600, color: getSeverityColor() }}>Duração: </Typography>
                                </Box>
                                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: getSeverityColor() }}>
                                    {tempo.split('.')[0]}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>Inicio: </Typography>
                                </Box>
                                <Typography sx={{ fontSize: "12px", fontWeight: 400 }}>
                                    {formatDateAndHour(dataHoraInicio)}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>Fim: </Typography>
                                </Box>
                                <Typography sx={{ fontSize: "12px", fontWeight: 400 }}>
                                    {dataHoraFim ? formatDateAndHour(dataHoraFim) : "Alarme se encontra ativo"}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: theme.primaryTextColor, marginBottom: "4px", textAlign: "left" }}>
                        {usina}
                    </Typography>
                    <Typography sx={{ fontSize: "13px", fontWeight: 400, color: theme.primaryTextColor, marginBottom: "2px", textAlign: "left" }}>
                        {descricao} - {detalhes}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
